{
	"access": {
		"ability": {
			"admins_manage": "Gestione admin"
		},
		"copy_user_id": "Copia ID utente",
		"no_permissions": "Nessun permesso",
		"permissions": "Permessi",
		"sign_in_method": "Metodo di accesso",
		"source": {
			"invite_accept": "Invito",
			"password": "Password",
			"password_reset": "Reset password",
			"previous": "Accesso precedente"
		},
		"title": "Accesso",
		"user_id": "ID utente"
	},
	"account": {
		"personal_data": {
			"name_max": "Il nome può contenere al massimo 100 caratteri.",
			"name_required": "Inserisci il tuo nome.",
			"title": "Dati personali"
		},
		"update_success": "Profilo aggiornato con successo."
	},
	"nav": {
		"personal": "Dati personali",
		"security": "Sicurezza"
	},
	"security": {
		"access": {
			"description": "Aggiorna la password usata per accedere al tuo account.",
			"email_code": {
				"email_code_sent": "Codice di verifica inviato. Controlla la tua casella di posta.",
				"email_resend_code": "Invia di nuovo il codice",
				"email_send_code": "Invia codice",
				"verify_label": "Codice di verifica"
			},
			"otp_hint": "Ti invieremo un codice via email per autorizzare il cambio password.",
			"success": "Password aggiornata con successo.",
			"use_current_password": "Usa la tua password attuale",
			"use_email_code": "Non hai una password? Usa un codice via email",
			"validation": {
				"current_required": "Inserisci la password attuale.",
				"max": "La password può contenere al massimo 255 caratteri."
			}
		},
		"password": {
			"title": "Password"
		}
	},
	"settings": {
		"account_description": "I tuoi dati personali e la password di accesso."
	},
	"title": "Profilo"
}
